module.exports = {
  onRouteUpdate() {
    window.gtag &&
      window.gtag('event', 'conversion', {
        send_to: `${process.env.GATSBY_AW_CONVERSION_ID}/3VxWCOWXm9gBEPb50aQC`,
      })
  },
}
